/**
 * Load Swiper after first paint. Mobile waits longer to protect Speed Index.
 * whenSwiperReady(callback)
 * whenSwiperReady(callback, { mobileDelay: 3500, desktopDelay: 800 })
 */
(function (window, document) {
  var loading = null;
  var loader = document.currentScript;
  var CSS_HREF = loader.getAttribute('data-swiper-css-url');
  var JS_HREF = loader.getAttribute('data-swiper-js-url');
  var queue = window.__swiperQueue || [];

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
  }

  function loadAsset() {
    if (loading) return loading;
    if (window.Swiper) return Promise.resolve();

    loading = new Promise(function (resolve, reject) {
      var pending = 2;
      function assetLoaded() {
        pending -= 1;
        if (pending === 0) resolve();
      }

      if (!document.querySelector('link[data-swiper-css]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = CSS_HREF;
        link.media = 'print';
        link.onload = function () {
          link.media = 'all';
          assetLoaded();
        };
        link.onerror = reject;
        link.setAttribute('data-swiper-css', 'true');
        document.head.appendChild(link);
      } else {
        assetLoaded();
      }

      var script = document.createElement('script');
      script.src = JS_HREF;
      script.async = true;
      script.onload = assetLoaded;
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return loading;
  }

  function schedule(fn, options) {
    options = options || {};
    var mobileDelay = options.mobileDelay != null ? options.mobileDelay : 3000;
    var desktopDelay = options.desktopDelay != null ? options.desktopDelay : 500;
    var delay = isMobile() ? mobileDelay : desktopDelay;

    var run = function () {
      setTimeout(fn, delay);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      run();
    }
  }

  function runCallback(callback, options) {
    if (!document.querySelector('.swiper')) return;
    schedule(function () {
      loadAsset().then(function () {
        if (typeof callback === 'function' && window.Swiper) callback();
      });
    }, options);
  }

  window.whenSwiperReady = function (callback, options) {
    runCallback(callback, options);
  };

  while (queue.length) {
    var item = queue.shift();
    if (typeof item === 'function') runCallback(item);
    else if (item && typeof item.cb === 'function') runCallback(item.cb, item.options);
  }
})(window, document);
